import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.catalogos.cartaporte_material_peligroso = {
      ...state.app.catalogos.cartaporte_material_peligroso,
      filters: {
        ...state.app.catalogos.cartaporte_material_peligroso.filters,
        ...meta,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.catalogos.cartaporte_material_peligroso;

    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      page: meta.page || 1,
    };

    const response = await Http.get('catalogos/carta-porte/material-peligroso', { params });

    store.setState((state) => {
      state.app.catalogos.cartaporte_material_peligroso = {
        ...state.app.catalogos.cartaporte_material_peligroso,
        busy: false,
        data: response.data,
        pagination: {
          ...state.app.catalogos.cartaporte_material_peligroso.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.catalogos.cartaporte_material_peligroso.busy = false;
      state.app.catalogos.cartaporte_material_peligroso.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.catalogos.cartaporte_material_peligroso = {
      ...initialState,
    };
  });
};

const CartaPorteMaterialPeligrosoSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default CartaPorteMaterialPeligrosoSuggestionsStore;
